/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_8_SolutionInputs */

const et_portfolio_project_8_solution = /** @type {(inputs: Portfolio_Project_8_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kujundasime ümber selguse nimel, parandasime UX-i ja optimeerisime kohaliku otsingu jaoks.`)
};

const en_portfolio_project_8_solution = /** @type {(inputs: Portfolio_Project_8_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redesigned for clarity, improved UX, and optimized for local search.`)
};

/**
* | output |
* | --- |
* | "Redesigned for clarity, improved UX, and optimized for local search." |
*
* @param {Portfolio_Project_8_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_8_solution = /** @type {((inputs?: Portfolio_Project_8_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_8_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_8_solution(inputs)
	return en_portfolio_project_8_solution(inputs)
});